module.exports = __webpack_public_path__ + "img/papel-toalha.c5754a64.png";